var _defs, _polygon, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSavedCommands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-32a51c7f-5f66-48f2-b67f-345fa61678b0",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-e65bb1ee-d95b-4415-b603-ad0a67a57af9 {\n        fill: #f2f2f2;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-e65bb1ee-d95b-4415-b603-ad0a67a57af9",
    points: "16 14.22 18.42 10.04 13.58 10.04 16 14.22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e65bb1ee-d95b-4415-b603-ad0a67a57af9",
    d: "M20.76,22.96h-9.52c-1.26,0-2.28-1.02-2.28-2.28v-3.43c0-1.26,1.02-2.28,2.28-2.28h9.52c1.26,0,2.28,1.02,2.28,2.28v3.43c0,1.26-1.02,2.28-2.28,2.28ZM11.24,16.97c-.16,0-.28.13-.28.28v3.43c0,.16.13.28.28.28h9.52c.16,0,.28-.13.28-.28v-3.43c0-.16-.13-.28-.28-.28h-9.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e65bb1ee-d95b-4415-b603-ad0a67a57af9",
    d: "M12.59,13.19h-2.85c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h2.85c.41,0,.75.34.75.75s-.34.75-.75.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e65bb1ee-d95b-4415-b603-ad0a67a57af9",
    d: "M22.24,13.19h-2.85c-.41,0-.75-.34-.75-.75s.34-.75.75-.75h2.85c.41,0,.75.34.75.75s-.34.75-.75.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedCommands);
export default __webpack_public_path__ + "static/media/SavedCommands.01c90ee3e706b150cccaa08111ff0b51.svg";
export { ForwardRef as ReactComponent };